import { ICellRendererParams } from "ag-grid-community";
import startCase from "lodash.startcase";
import { DateTime } from "luxon";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { OrganizationSummarySubscriptionProductDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { Tag } from "@src/components/BillingPanel/components/Products/components/PriceBox/Tag";
import {
  CurrencyFormat,
  DecimalFormat,
} from "@src/features/admin/components/utils";

import { formatDeprecatedName } from "../deprecated-subscription-utils";

export const CurrentPeriodColumn = (
  params: ICellRendererParams<
    OrganizationSummarySubscriptionProductDto & { stripeSubscriptionId: string }
  >
) => {
  if (!params.data) {
    return null;
  }

  if (
    !params.data.subscriptionSummary?.periodStart ||
    !params.data.subscriptionSummary?.periodEnd
  ) {
    return null;
  }

  return (
    <Grid container item columnSpacing={2}>
      <IgTypography variant={"body2"}>
        <IgTypography variant={"body2"}>
          {DateTime.fromSeconds(
            params.data.subscriptionSummary.periodStart
          ).toLocaleString(DateTime.DATE_SHORT)}
        </IgTypography>
        <br />
        <IgTypography variant={"body2"}>
          {" "}
          -{" "}
          {DateTime.fromSeconds(
            params.data.subscriptionSummary.periodEnd
          ).toLocaleString(DateTime.DATE_SHORT)}
        </IgTypography>
      </IgTypography>
    </Grid>
  );
};
